<div class="middle-box text-center lockscreen animated fadeInDown">
    <span>{{ 'Pages.Login.SSOOnly' | translate }} </span>
</div>
